import React, {useCallback, useEffect, useState} from "react";
import styled, {css} from "styled-components";
import {useSelector} from "react-redux";
import AddButtonFullText from "../buttons/AddButtonFullText";
import ObjectiveModal from "../modal/ObjectiveModal";
import {DisplayForHead} from "../../permissions/DisplayAccordingToRole";
import {Input} from "../inputs/radioStyles";
import Loader from "../progress-bar/Loader";
import {getImage, getWeatherImage} from "../../utils/utils";
import axisSvg from "../../images/axis/axis.svg";
import _ from "lodash";
import accountSvg from "../../images/account.svg";
import SummaryButton from "../buttons/SummaryButton";
import ObjectiveCascadeCard from "./ObjectivesCascade/ObjectiveCascadeCard";

const Objectives = ({
                        objectives,
                        isInteractive,
                        projectId = 0,
                        inPitchProject = false,
                        inObjectivePage,
                    }) => {

    const currentUser = useSelector(state => state.currentUser)
    const project = useSelector(state => state.project)

    const [openCreateModal, setOpenCreateModal] = useState(false);


    const hasException = () => {
        return (project?.pilot?.id === currentUser.id) || (project.copilot ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)
    }

    const displayCreateOKRModal = () => {
        if (openCreateModal) {
            return (
                <ObjectiveModal
                    setOpen={setOpenCreateModal}
                    selectedObjectiveId={0}
                    projectId={projectId}
                    pilotId={project.pilot.id}
                />
            )
        }
    }
    const [showComponent, setShowComponent] = useState(true);
    const [preFilter, setPreFilter] = useState("all");
    const [filter, setFilter] = useState({
        axisId: [],
        years: [],
        weathers: [],
        pilotsId: [],
        copilotsId: [],
        tags: [],
        lastUpdate: [],
        search: "",
    });
    const [upToDateOKRs, setUpToDateOKRs] = useState([])
    const [lateOKRs,setLateOKRs] = useState([])

    const getLateInfo = () => {
        const today = new Date();
        let late = [];
        let upToDate = []
        objectives
            .filter(filterPredicate)
            .sort(orderPredicate).map((o) => {
            const lastUpdate = Date.parse(o.lastUpdate)
            const time = Math.abs(lastUpdate - today)
            const res = Math.ceil(time / (1000 * 60 * 60 * 24));
            if(res <= 30){
                upToDate.push(o.lastUpdate)
            }
            if(res > 30 || !res){
                late.push(o.lastUpdate)
            }
            return [late, upToDate];
        })
        setUpToDateOKRs(upToDate)
        setLateOKRs(late)
        return [late, upToDate];
    }
    useEffect(() => {
        getLateInfo();
    }, [currentUser, preFilter, filter])

    const currentPilot = useCallback(() => {
        setPreFilter("pilot");
        setFilter((prev) => ({
            ...prev,
            pilotsId: [currentUser.id],
            lastUpdate: [],
        }));
    }, [currentUser.id]);

    const clearFilter = () => {
        setFilter({
            axisId: [],
            years: [],
            weathers: [],
            pilotsId: [],
            copilotsId: [],
            tags: [],
            search: "",
        })

        reset();
    }

    const filterUpToDate = () => {
        setFilter((prev) => ({
            ...prev,
            lastUpdate: [...upToDateOKRs],
        }));
    }

    const filterLate = () => {
        setFilter((prev) => ({
            ...prev,
            lastUpdate: [...lateOKRs],
        }));
    }

    useEffect(() => {
        if(inObjectivePage){
            currentPilot();
        }
    }, [currentPilot, inObjectivePage]);
    const [order, setOrder] = useState("none");

    const filterPredicate = useCallback(
        (o) => {
            let year;

            if (o.endDate) {
                year = new Date(o.endDate).getFullYear();
            } else if (o.startDate) {
                year = new Date(o.startDate).getFullYear();
            } else if (o.lastUpdate) {
                year = new Date(o.lastUpdate).getFullYear();
            }

            const searchFilter =
                filter.search === "" ||
                o.title.toLowerCase().includes(filter.search.toLowerCase()) || o.pilot.lastName.toLowerCase().includes(filter.search.toLowerCase()) || o.pilot.firstName.toLowerCase().includes(filter.search.toLowerCase());

            const pilotFilter =
                filter.pilotsId.length === 0 || filter.pilotsId.includes(o.pilot?.id);

            const copilotFilter =
                filter.copilotsId.length === 0 ||
                filter.copilotsId.includes(o.coPilot?.id);

            const axisFilter =
                filter.axisId.length === 0 || filter.axisId.includes(o.axisId);

            const weatherFilter =
                filter.weathers.length === 0 || filter.weathers.includes(o.weather);

            const tagsFilter =
                filter.tags.length === 0 ||
                filter.tags.some((t) => o.tags?.map((n) => n.name).includes(t)) ||
                filter.tags.some((t) => o.tags?.map((n) => n.category).includes(t));
            const yearFilter =
                (year && filter.years.length === 0) || filter.years.includes(year);

            const lastUpdateFilter = filter.lastUpdate?.length === 0 || filter.lastUpdate?.includes(o.lastUpdate)

            return (
                searchFilter &&
                pilotFilter &&
                copilotFilter &&
                axisFilter &&
                yearFilter &&
                weatherFilter &&
                tagsFilter &&
                lastUpdateFilter
            );
        },
        [filter]
    );

    const weatherTranslate = (weather) => {
        switch (weather) {
            case "sunny":
                return 1;
            case "cloudy":
                return 2;
            case "rainy":
                return 3;
            case "stormy":
                return 4;
            default:
                return null;
        }
    };

    const orderPredicate = useCallback(
        (p1, p2) => {
            let date1, date2;
            if (p1.endDate) {
                date1 = new Date(p1.endDate);
            } else if (p1.startDate) {
                date1 = new Date(p1.startDate);
            } else if (p1.lastUpdate) {
                date1 = new Date(p1.lastUpdate);
            }

            if (p2.endDate) {
                date2 = new Date(p2.endDate);
            } else if (p2.startDate) {
                date2 = new Date(p2.startDate);
            } else if (p2.lastUpdate) {
                date2 = new Date(p2.lastUpdate);
            }

            switch (order) {
                case "title":
                    return p1.title.localeCompare(p2.title);
                case "pilotNameAZ":
                    return p1.pilot.firstName.localeCompare(p2.pilot.firstName);
                case "pilotNameZA":
                    return p2.pilot.firstName.localeCompare(p1.pilot.firstName);
                case "youngest":
                    return date1 - date2;
                case "oldest":
                    return date2 - date1;
                case "goodWeather":
                    return weatherTranslate(p1.weather) - weatherTranslate(p2.weather);
                case "badWeather":
                    return weatherTranslate(p2.weather) - weatherTranslate(p1.weather);
                case "progressUp":
                    return p2.advancement - p1.advancement;
                case "progressDown":
                    return p1.advancement - p2.advancement;
                default:
                    return null;
            }
        },
        [order]
    );

    const reset = () => {
        setPreFilter("all");
        setFilter((prev) => ({ ...prev, pilotsId: [], copilotsId: [] , lastUpdate: []}));
    };

    return (
        <>
            {displayCreateOKRModal()}
            {isInteractive &&
                <DisplayForHead
                    hasException={hasException()}
                    component={<AddButtonFullText
                        setUpdate={setOpenCreateModal}
                        title={"Ajouter un OKR"}
                    />}/>
            }
            <>
                <div style={{ display: "flex", gap: 24, height: inPitchProject ? "auto" : "75vh" }}>
                    {
                        inObjectivePage &&

                        <div style={{ width: "18%", overflowY: "auto" }}>
                            <div
                                style={{
                                    marginBottom: "0.8rem",
                                    marginLeft: "0.2rem",
                                }}
                            >
                                <SummaryButton setOpen={setShowComponent} open={showComponent} />
                            </div>
                            <div>
                                {showComponent && (
                                    <div>
                                        <p style={{ fontSize: 20 }}>Affinez votre recherche</p>

                                        <p
                                            style={{
                                                color: "var(--color-purple)",
                                                cursor: "pointer",
                                                marginBottom: 12,
                                                fontSize: 12,
                                            }}
                                            onClick={clearFilter}
                                        >
                                            Tout réinitaliser
                                        </p>

                                        <Input
                                            type="text"
                                            placeholder={"Recherchez un OKR ou pilote"}
                                            value={filter.search}
                                            style={{ marginBottom: 12, width: "100%", borderRadius: 8 }}
                                            onChange={(event) => {
                                                const value = event.target.value;
                                                setFilter((prev) => ({
                                                    ...prev,
                                                    search: value,
                                                }));
                                            }}
                                        />

                                        <AxisMenuFilter
                                            filter={filter}
                                            onChange={(values) =>
                                                setFilter((prev) => ({ ...prev, axisId: values }))
                                            }
                                            displayGrid
                                        />
                                        <PilotsFilter
                                            projects={objectives}
                                            filter={filter}
                                            onChange={(values) =>
                                                setFilter((prev) => ({ ...prev, pilotsId: values }))
                                            }
                                        />
                                        <TagsFilter
                                            filter={filter}
                                            onChange={(values) =>
                                                setFilter((prev) => ({ ...prev, tags: values }))
                                            }
                                        />
                                        <WeatherFilter
                                            filter={filter}
                                            onChange={(values) =>
                                                setFilter((prev) => ({ ...prev, weathers: values }))
                                            }
                                        />
                                        <YearsMenuFilter
                                            projects={objectives}
                                            filter={filter}
                                            onChange={(values) =>
                                                setFilter((prev) => ({ ...prev, years: values }))
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    }

                    <OkrDisplay $mode={inObjectivePage}>
                        {currentUser.isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        width: "90%",
                                        marginBottom: 12,
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    {objectives.filter(filterPredicate).length === 0 ? (
                                        preFilter === "pilot" ? (
                                            <h2>Vous ne pilotez pas encore d'OKR</h2>
                                        ) : (
                                            <h2> Pas de OKR avec cette sélection </h2>
                                        )
                                    ) : (
                                        <h2>
                                            {objectives.filter(filterPredicate).length} OKRs
                                            correspondants
                                        </h2>
                                    )}
                                    {
                                        inObjectivePage &&

                                        <select
                                            style={{ borderRadius: 8, padding: 8 }}
                                            onChange={(event) => {
                                                setOrder(event.target.value);
                                            }}
                                        >
                                            <option value="none">Trier les OKRs</option>
                                            <option value="title">Titre</option>
                                            <option value="pilotNameAZ">Nom du pilote (A-Z)</option>
                                            <option value="pilotNameZA">Nom du pilote (Z-A)</option>
                                            <option value="goodWeather">Météo + à -</option>
                                            <option value="badWeather">Météo - à +</option>
                                            <option value="youngest">
                                                Échéance la plus courte
                                            </option>
                                            <option value="oldest">
                                                Échéance la plus lointaine
                                            </option>
                                        </select>
                                    }
                                </div>
                                {
                                    inObjectivePage &&
                                    <PreFilterContainer>
                                        <PreFilterButton
                                            className={preFilter === "all" ? "selected" : ""}
                                            onClick={reset}
                                        >
                                            Tous
                                        </PreFilterButton>
                                        <PreFilterButton
                                            className={preFilter === "pilot" ? "selected" : ""}
                                            onClick={currentPilot}
                                        >
                                            Que je pilote
                                        </PreFilterButton>
                                        {
                                            lateOKRs?.length > 0 &&
                                            <PreFilterButton onClick={filterLate} $mode={"late"}>
                                                {lateOKRs?.length} à mettre à jour
                                            </PreFilterButton>
                                        }
                                        {
                                            upToDateOKRs.length > 0 &&
                                            <PreFilterButton onClick={filterUpToDate} $mode={"upToDate"}>
                                                {upToDateOKRs.length} à jour
                                            </PreFilterButton>
                                        }
                                    </PreFilterContainer>
                                }
                            </>
                        )}
                        <div
                            style={{
                                overflowY: "auto",
                                paddingBottom: "20px",
                            }}
                        >
                                <List>
                                    {objectives
                                        .filter(filterPredicate)
                                        .sort(orderPredicate)
                                        .map((o) => (
                                            <ObjectiveCascadeCard key={o.id} objective={o}/>
                                        ))}
                                </List>
                        </div>
                    </OkrDisplay>
                </div>
            </>
        </>
    )
}

const ContainerFilter = ({ title, count, onReset, children }) => {
    const [collapsed, setCollapsed] = useState(true);

    return (
        <div style={{ overflow: "hidden", marginBottom: collapsed ? 0 : 24 }}>
            <div
                style={{
                    display: "flex",
                    paddingLeft: 12,
                    paddingRight: 12,
                    paddingTop: 6,
                    paddingBottom: 6,
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                    borderLeft: "4px solid var(--color-purple)",
                    borderRight: "4px solid var(--color-purple)",
                    borderRadius: 12,
                    background: "var(--color-grey-03)",
                    cursor: "pointer",
                    userSelect: "none",
                }}
                onClick={() => {
                    setCollapsed((prev) => !prev);
                }}
            >
                <p
                    style={{
                        fontSize: 16,
                        color: "var(--color-purple)",
                    }}
                >
                    {title} {count ? `(${count})` : ""}
                </p>
                <p
                    aria-label="button"
                    style={{
                        fontSize: 16,
                        color: "var(--color-purple)",
                    }}
                >
                    {collapsed ? "+" : "-"}
                </p>
            </div>

            <div
                style={{
                    maxHeight: collapsed ? 0 : 2000,
                    transition: "all 0.5s ",
                }}
            >
                {children}

                {count > 0 && (
                    <p
                        style={{
                            color: "var(--color-purple)",
                            cursor: "pointer",
                            marginTop: 12,
                            fontSize: 12,
                        }}
                        onClick={onReset}
                    >
                        Réinitaliser
                    </p>
                )}
            </div>
        </div>
    );
};

const ContainerAxisFilter = ({
                                 title,
                                 count,
                                 onReset,
                                 displayGrid,
                                 children,
                             }) => {
    return (
        <div
            style={{
                overflow: "hidden",
                marginBottom: 24,
                ...(displayGrid && {
                    width: "80%",
                }),
            }}
        >
            <div
                style={{
                    display: "flex",
                    paddingLeft: 12,
                    paddingRight: 12,
                    paddingTop: 6,
                    paddingBottom: 6,
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                    borderLeft: "4px solid var(--color-purple)",
                    borderRight: "4px solid var(--color-purple)",
                    borderRadius: 12,
                    background: "var(--color-grey-03)",
                    cursor: "pointer",
                    userSelect: "none",
                }}
            >
                <p
                    style={{
                        fontSize: 16,
                        color: "var(--color-purple)",
                    }}
                >
                    {title} {count ? `(${count})` : ""}
                </p>
            </div>

            <div
                style={{
                    ...(displayGrid && {
                        display: "grid",
                        gridTemplateColumns: "repeat(5, 1fr)",
                    }),

                    maxHeight: 1000,
                    transition: "all 0.5s ",
                }}
            >
                {children}

                {count > 0 && (
                    <p
                        style={{
                            color: "var(--color-purple)",
                            cursor: "pointer",
                            marginTop: 12,
                            fontSize: 13,
                        }}
                        onClick={onReset}
                    >
                        Réinitaliser
                    </p>
                )}
            </div>
        </div>
    );
};

const YearsMenuFilter = ({ projects, filter, onChange }) => {
    const getYears = useCallback(() => {
        const years = projects
            .map((p) =>
                p.endDate ? p.endDate : p.startDate ? p.startDate : p.lastUpdate
            )
            .filter((d) => d)
            .map((d) => new Date(d).getFullYear());

        return [...new Set(years)].sort((a, b) => a - b);
    }, [projects]);

    return (
        <ContainerFilter title="Année" count={0} onReset={() => onChange([])}>
            {getYears().map((year) => (
                <div
                    key={year}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        gap: 8,
                    }}
                    onClick={() => {
                        if (filter.years.includes(year)) {
                            onChange(filter.weathers.filter((x) => x !== year));
                        } else {
                            onChange([year]);
                        }
                    }}
                >
                    <input type="checkbox" checked={filter.years.includes(year)} />

                    <p
                        style={{
                            fontSize: 13,
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: 300,
                        }}
                    >
                        {year}
                    </p>
                </div>
            ))}
        </ContainerFilter>
    );
};


const AxisMenuFilter = ({filter, onChange}) => {
    const {axis} = useSelector((state) => state.axis);
    const strategicAxis = axis.filter(a => a.isStrategic === true)
    const nonStrategicAxis = axis.filter(a => a.isStrategic === false)

    return (
        <ContainerAxisFilter
            title="Axes"
            count={filter.axisId.length}
            onReset={() => onChange([])}
        >
            <h3 style={{color:"var(--color-purple)", paddingBottom:"0.2rem"}} >Axes stratégiques :</h3>
            {strategicAxis.map((a) => (
                <div
                    key={"axis" + a.id}
                    title={a.name}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        gap: 4,
                    }}
                    onClick={() => {
                        if (filter.axisId.includes(a.id)) {
                            onChange(filter.axisId.filter((id) => id !== a.id));
                        } else {
                            onChange([...filter.axisId, a.id]);
                        }
                    }}
                >
                    <input type="checkbox" checked={filter.axisId.includes(a.id)}/>

                    <div style={{display: "flex", gap: 4}}>
                        <img
                            style={{
                                width: 22,
                                height: 22,
                                background: "var(--color-white)",
                                borderRadius: "50%",
                            }}
                            src={getImage(a.image, axisSvg)}
                            alt={a.name}
                        />
                        <p
                            style={{
                                fontSize: 13,
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                maxWidth: 200,
                            }}
                        >
                            {a.name}
                        </p>
                    </div>
                </div>
            ))}
            <h3 style={{color:"var(--color-purple)", paddingBottom:"0.2rem"}} >Autres axes:</h3>
            {nonStrategicAxis.map((a) => (
                <div
                    key={"axis" + a.id}
                    title={a.name}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        gap: 4,
                    }}
                    onClick={() => {
                        if (filter.axisId.includes(a.id)) {
                            onChange(filter.axisId.filter((id) => id !== a.id));
                        } else {
                            onChange([...filter.axisId, a.id]);
                        }
                    }}
                >
                    <input type="checkbox" checked={filter.axisId.includes(a.id)}/>

                    <div style={{display: "flex", gap: 4}}>
                        <img
                            style={{
                                width: 22,
                                height: 22,
                                background: "var(--color-white)",
                                borderRadius: "50%",
                            }}
                            src={getImage(a.image, axisSvg)}
                            alt={a.name}
                        />
                        <p
                            style={{
                                fontSize: 13,
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                maxWidth: 200,
                            }}
                        >
                            {a.name}
                        </p>
                    </div>
                </div>
            ))}
        </ContainerAxisFilter>
    );
};

const PilotsFilter = ({ projects, filter, onChange }) => {
    const getPilots = useCallback(() => {
        const pilots = projects
            .filter(
                (p) =>
                    filter.axisId.includes(p.stake?.axisId) || filter.axisId.length === 0
            )
            .map((p) => p.pilot);
        return _.uniqBy(pilots, "id");
    }, [filter.axisId, projects]);

    return (
        <ContainerFilter
            title="Pilotes"
            count={filter.pilotsId.length}
            onReset={() => onChange([])}
        >
            {getPilots().map((p) => (
                <div
                    key={"pilot" + p.id}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        gap: 24,
                    }}
                    onClick={() => {
                        if (filter.pilotsId.includes(p.id)) {
                            onChange(filter.pilotsId.filter((id) => id !== p.id));
                        } else {
                            onChange([...filter.pilotsId, p.id]);
                        }
                    }}
                >
                    <input type="checkbox" checked={filter.pilotsId.includes(p.id)} />
                    <img
                        style={{
                            width: 22,
                            height: 22,
                            background: "var(--color-white)",
                            borderRadius: "50%",
                        }}
                        src={getImage(p.photo, accountSvg)}
                        alt={p.name}
                    />
                    <p
                        style={{
                            fontSize: 13,
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: 300,
                        }}
                    >
                        {p.firstName + " " + p.lastName}
                    </p>
                </div>
            ))}
        </ContainerFilter>
    );
};

const WeatherFilter = ({ filter, onChange }) => {
    const weathers = ["sunny", "cloudy", "rainy", "stormy"];

    return (
        <ContainerFilter
            title="Météo"
            count={filter.weathers.length}
            onReset={() => onChange([])}
        >
            {weathers.map((w) => (
                <div
                    key={w}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        gap: 8,
                    }}
                    onClick={() => {
                        if (filter.weathers.includes(w)) {
                            onChange(filter.weathers.filter((x) => x !== w));
                        } else {
                            onChange([...filter.weathers, w]);
                        }
                    }}
                >
                    <input type="checkbox" checked={filter.weathers.includes(w)} />
                    <img
                        src={getWeatherImage(w)}
                        height={35}
                        width={35}
                        alt="icone météo"
                    />

                    <p
                        style={{
                            fontSize: 13,
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: 300,
                        }}
                    >
                        {w.name}
                    </p>
                </div>
            ))}
        </ContainerFilter>
    );
};

const TagsFilter = ({ filter, onChange }) => {
    const { tagCategories } = useSelector((state) => state.tagCategories);
    return (
        <ContainerFilter
            title="Tags"
            count={filter.tags.length}
            onReset={() => onChange([])}
        >
            {tagCategories?.map((tc) => (
                <div key={tc.id}>
                    <div
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: 8,
                        }}
                        onClick={() => {
                            if (filter.tags.includes(tc.name)) {
                                onChange(filter.tags.filter((x) => x !== tc.name));
                            } else {
                                onChange([...filter.tags, tc.name]);
                            }
                        }}
                    >
                        <input type="checkbox" checked={filter.tags.includes(tc.name)} />
                        <p>{tc.name}</p>
                    </div>

                    {tc.tags?.map((t) => (
                        <div
                            key={t.id}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                gap: 8,
                            }}
                            onClick={() => {
                                if (filter.tags.includes(t.name)) {
                                    onChange(filter.tags.filter((x) => x !== t.name));
                                } else {
                                    onChange([...filter.tags, t.name]);
                                }
                            }}
                        >
                            <input type="checkbox" checked={filter.tags.includes(t.name)} />
                            <p>
                                {tc.name} / {t.name}
                            </p>
                        </div>
                    ))}
                </div>
            ))}
        </ContainerFilter>
    );
};

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin: 40px;
  @media (min-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;

const PreFilterButton = styled.button`
  padding: 0.5rem;
  border: 1px solid var(--color-purple);
  border-radius: 10px;
  color: var(--color-purple);
  cursor: pointer;

  :hover {
    background-color: var(--color-purple);
    color: white;
  }
  ${(props) =>{
    switch (props.$mode){
        case "late":
            return css`
              background-color: var(--color-yellow);
              border: 1px solid var(--color-yellow);
              color: white;
              :hover{
                color: var(--color-yellow);
                background-color: var(--color-white);
              }
            `;
        case "upToDate":
            return css`
              background-color: var(--color-green);
              border: 1px solid var(--color-green);
              color: white;
              :hover{
                color: var(--color-green);
                background-color: var(--color-white);
              }
            `;
        default:
            return;
    }
}}
`;

const PreFilterContainer = styled.div`
  display: flex;
  gap: 2rem;
  padding: 1rem;

  .selected {
    background-color: var(--color-purple);
    color: white;
  }
`;

const OkrDisplay = styled.div`  
  display: flex;
  flex-direction: column;
  height: 100%;
  ${(props) => {
      switch (props.$mode){
        case true:
            return css`
              width: 80%;
            `;
        case false:
            return css`
            width: 100%;
            `
        default:
            return;
      }
  }}
`


export default Objectives;
